import React from 'react'
import moment from 'moment'
import MaterialNewModal from '../MaterialEditModal'

const TableRow = ({ item, loading, setLoading, onReload }) => {
    const { name, updated, code, description, partner } = { ...item }
    return (
        <tr>
            <td>{!!name ? name : ''}</td>
            <td>{!!description ? description : ''}</td>
            <td>{!!code ? code : ''}</td>
            <td>{!!partner ? partner.name : ''}</td>
            <td>{!!updated ? moment(updated).format("DD/MM/YYYY HH:mm:ss") : ''}</td>
            <td>
                <MaterialNewModal
                    item={item}
                    loading={loading}
                    setLoading={setLoading}
                    onReload={onReload}
                />
            </td>
        </tr>
    )
}

export default TableRow